export function checkForPaidRespondents(respondents) {
  let paidRespondentsFound = false;

  if (!respondents || respondents.length === 0) {
    return false;
  }

  const paidStrings = ["Paid", "MarkedAsPaid"];

  respondents.forEach((r) => {
    if (paidStrings.includes(r.paymentStatus)) {
      paidRespondentsFound = true;
      return;
    }

    r.additionalNames?.forEach((adName) => {
      if (paidStrings.includes(adName.paymentStatus)) {
        paidRespondentsFound = true;
        return;
      }
    });

    r.householdRespondents?.forEach((hhr) => {
      if (paidStrings.includes(hhr.paymentStatus)) {
        paidRespondentsFound = true;
        return;
      }
    });
  });

  return paidRespondentsFound;
}
